import dayjs from 'dayjs';
import { useState, useEffect } from 'react';

type UseCurrentDateOptions = {
  refreshTimeout?: number; // Milliseconds
};

export const useCurrentDate = ({ refreshTimeout }: UseCurrentDateOptions) => {
  const [currentDate, setCurrentDate] = useState(dayjs());

  useEffect(() => {
    if (refreshTimeout && refreshTimeout > 0) {
      const interval = setInterval(() => {
        setCurrentDate(dayjs());
      }, refreshTimeout);

      return () => clearInterval(interval);
    }

    return;
  }, [refreshTimeout]);

  return { currentDate };
};
